
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"red"}},[_c('path',{attrs:{"d":"M497.6 244.7C433.7 148 347.9 94.7 256 94.7S78.3 148 14.4 244.7c-4.5 6.8-4.5 15.7 0 22.5 63.9 96.7 149.7 150 241.6 150s177.7-53.3 241.6-150c4.5-6.8 4.5-15.6 0-22.5zM256 376.4c-74.2 0-144.8-42.6-199.9-120.4 55-77.8 125.6-120.4 199.9-120.4 74.2 0 144.8 42.6 199.9 120.4-55.1 77.8-125.6 120.4-199.9 120.4z"}}),_c('path',{attrs:{"d":"M256 148.5c-59.3 0-107.5 48.2-107.5 107.5S196.7 363.5 256 363.5 363.5 315.3 363.5 256 315.3 148.5 256 148.5zm0 175.5c-36.8 0-66.8-30.5-66.8-68s30-68 66.8-68 66.8 30.5 66.8 68-30 68-66.8 68z"}})])])
          )
        }
      }
    